/**
 * Keeps cart "You May Also Like" recommendations in sync after cart updates.
 */
(function () {
  const SELECTOR = '[data-cart-recommendations]';
  const API_SELECTOR = '[data-api-cart-recommendations]';
  const EMPTY_CLASS = 'cart-recs-holder--empty';

  function cartSectionUrl() {
    const cartUrl = (window.theme && window.theme.routes && window.theme.routes.cart_url) || '/cart';
    return cartUrl + '?section_id=api-cart-items';
  }

  function cartIsEmpty() {
    const qtyEl = document.querySelector('[data-cart-items-qty]');
    if (qtyEl && qtyEl.classList.contains('hidden')) return true;

    const itemsHolder = document.querySelector('[data-items-holder]');
    if (itemsHolder && itemsHolder.classList.contains('hidden')) return true;

    return false;
  }

  function refreshRecommendations() {
    const holders = document.querySelectorAll(SELECTOR);
    if (!holders.length) return;

    fetch(cartSectionUrl())
      .then(function (response) {
        return response.text();
      })
      .then(function (html) {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const next = doc.querySelector(API_SELECTOR);
        if (!next) return;

        const empty = cartIsEmpty();
        holders.forEach(function (holder) {
          holder.innerHTML = next.innerHTML;
          holder.classList.toggle(EMPTY_CLASS, empty);
        });
      })
      .catch(function () {});
  }

  document.addEventListener('theme:cart:added', refreshRecommendations);
})();
